import { Injectable } from '@angular/core';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './selected-matter-forms.actions';
import { PDFFormType } from '@models/matter-form-data';

@Injectable({
	providedIn: 'root',
})
export class SelectedMatterFormsDispatch {
	@Dispatch()
	SelectForm = (
		formType: PDFFormType,
		formId?: string,
		mortgageId?: string,
	): actions.SelectForm =>
		new actions.SelectForm({ formType, formId, mortgageId });

	@Dispatch()
	SetSelectedFormField = (
		field: string,
		value: string,
	): actions.SetSelectedFormField =>
		new actions.SetSelectedFormField({ field, value });
}
